module.exports = __webpack_public_path__ + "tree-round.svg?328d9f36425ec466cbb391c164166216";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tree-round.svg
// module id = 157
// module chunks = 0